export const NAME_STARTS_WITH_MATCHER = /^[A-Za-z]/i;

export const INVALID_NAME_MATCHER = /[^A-Za-z0-9_-]/gi;

export const replaceInvalidNameChars = (text: string) =>
  text.replace(INVALID_NAME_MATCHER, '_');
